import React, { useContext, useEffect, useState } from 'react'
import { Compass, GearFill } from 'react-bootstrap-icons'
import { NavLink, Outlet, useNavigate, useParams } from 'react-router-dom'
import Authentication from '../../libs/api/services/Authentication'
import Patient from '../../libs/api/services/Patient'
import User from '../../libs/api/services/User'
import StickyNavigationContext from '../../libs/providers/StickyNavigationProvider'
import CommonFunctionsContext from '../common/CommonFunctionsProvider'
import PatientContext from '../section/patient/management/PatientProvider'
import Notifications from './components/Notifications'

export default function SearchBarWrapper({ showNotifications, search, breadcrums, settings, options }) {
    const { id } = useParams()
    const [toggleBCSmall, setToggleBCSmall] = useState(false)
    const { GlobalRef } = useContext(CommonFunctionsContext)

    return (
        <div
            key={"SB_CONTAINER"}
            className='d-flex bg-primary-container rounded rounded-4 shadow align-items-center '>
            <Outlet />
            <nav aria-label="breadcrumb">
                <button
                    onClick={(e) => setToggleBCSmall(!toggleBCSmall)}
                    className='d-block d-lg-none btn'>
                    <Compass />
                </button>
                <BreadCrumbProvider PatientId={id} UserId={id}>
                    <div className=
                        {'position-fixed breadcrumb-sm rouned shadow '.concat(!toggleBCSmall ? 'hide' : 'show')}>
                        <BreadCrumsBar breadcrums={breadcrums} search={search} />
                    </div>

                    <ol className="breadcrumb breadcrumb-arrow p-0 m-0 d-none d-lg-block">
                        <BreadCrumsBar breadcrums={breadcrums} search={search} />
                    </ol>
                </BreadCrumbProvider>
            </nav>
            <div className='flex-grow-1'>
                {
                    (search)
                        ?
                        <div className="row flex-shrink-1">
                            <div className="col-12 mt-1 m-md-1 text-primary">
                                <div className="row">
                                    {search}
                                    {/* <div className="col-6">
                                                    <input className='form-control bg-search-bar rounded-3 text-white' placeholder='Patient Search' />
                                                </div>
                                                <div className="col-6">
                                                    <input className='btn bg-buttons' />
                                                </div> */}

                                </div>
                            </div>
                        </div>
                        :
                        <></>
                }
            </div>
            <div className='flex-shrink-1 text-light d-flex align-items-center'>
                {
                    settings && !Authentication.getShareID()
                        ?
                        <NavLink
                            ref={r => GlobalRef(r, 'FaciltyConfigurationsButton')}
                            to={`/Dashboard/configuration`}
                            className={'text-light'}
                        >
                            <GearFill className='me-2' size={25}
                                style={{ cursor: 'pointer' }}
                            // onClick={(e) => window.location = Authentication.getFacilityRole() + '/configuration'}
                            />
                        </NavLink>
                        :
                        <></>
                }
                {
                    showNotifications && !Authentication.getShareID()
                        ?
                        <>

                            <Notifications options={options} />
                        </>
                        :
                        <></>
                }
            </div>
        </div>
    )
}

const BreadCrumbContext = React.createContext()

const BreadCrumbProvider = ({ PatientId, UserId, children }) => {
    const { activePatient } = useContext(PatientContext)
    const [lastPatientId, setLastPatientId] = useState()
    const [lastUserId, setUserId] = useState()
    const [cache, setCache] = useState({
        '[PatientName]': { lastId: undefined, value: undefined },
        '[PatientID]': { lastId: undefined, value: undefined },
        '[UserName]': { lastId: undefined, value: undefined },
        '[UserID]': { lastId: undefined, value: undefined },
    })

    useEffect(() => {
        if (activePatient) {
            setCache({
                ...cache,
                '[PatientID]': { lastId: activePatient.id, value: activePatient.id },
                '[PatientName]': { lastId: PatientId, value: `${activePatient.userProfile.firstName} ${activePatient.userProfile.lastName}` },
            })
        }
    }, [activePatient])

    useEffect(() => {
        if (PatientId && lastPatientId !== PatientId) {
            try {
                Patient.GetById(PatientId).then((_patientDetails) => {
                    setCache({
                        ...cache,
                        '[PatientID]': { lastId: PatientId, value: PatientId },
                        '[PatientName]': { lastId: PatientId, value: `${_patientDetails.userProfile.firstName} ${_patientDetails.userProfile.lastName}` },
                    })
                    setLastPatientId(PatientId)
                }).catch((e) => { })
            } catch (e) { }
        }
        if (UserId && lastUserId !== UserId) {
            try {
                User.get(PatientId).then((_userDetails) => {
                    setCache({
                        ...cache,
                        '[UserID]': { lastId: UserId, value: UserId },
                        '[UserName]': { lastId: UserId, value: `${_userDetails.firstName} ${_userDetails.lastName}` },
                    })
                    setUserId(UserId)
                }).catch((e) => { })
            } catch (e) { }
        }
    }, [PatientId, UserId, lastPatientId])

    const findValue = (o) => {

        if (o.includes('[PatientName]')) { return cache['[PatientName]'].value; }
        if (o.includes('[PatientID]')) { return o.replaceAll('[PatientID]', cache['[PatientID]'].value); }
        if (o.includes('[UserName]')) { return cache['[UserName]'].value; }
        if (o.includes('[UserID]')) { return o.replaceAll('[UserID]', cache['[UserID]'].value); }
        else return o
    }
    return <BreadCrumbContext.Provider value={{
        findValue
    }}>
        {children}
    </BreadCrumbContext.Provider>
}


const BreadCrumsBar = ({ breadcrums, search }) => {
    const navigate = useNavigate();
    const { canNavigate } = useContext(StickyNavigationContext)
    const { findValue } = useContext(BreadCrumbContext)

    if (!breadcrums) return
    return (
        breadcrums.map((crumb, i) =>
            i === 0
                ?
                <li
                    key={"sbw-bc-" + i}
                    className={"breadcrumb-item ".concat(crumb.active ? 'active' : '').concat(!search ? 'ps-0' : 'ps-2')} >
                    <a key={"sbw-bc-nl-" + + new Date().getTime()}
                        className={"btn shadow ".concat(crumb.active ? 'active' : '')}
                        onClick={() => canNavigate(() => crumb.location && navigate(findValue(crumb.location)))}
                    >
                        {findValue(crumb.name)}
                    </a>
                </li>
                :
                crumb.active
                    ?
                    <li
                        key={"sbw-bc-" + i}
                        className={"breadcrumb-item  rounded rounded-3 ".concat(crumb.active ? 'active' : '')} >
                        {crumb.name}
                    </li>
                    :
                    <li
                        key={"sbw-bc-" + i}
                        className={"breadcrumb-item  ps-0 ".concat(crumb.active ? 'active' : '')} >
                        <a key={"sbw-bc-nl-" + + new Date().getTime()}
                            className={"btn ".concat(crumb.active ? 'active' : '')}
                            onClick={() => canNavigate(() => crumb.location && navigate(findValue(crumb.location)))}

                        >
                            {findValue(crumb.name)}
                        </a>
                    </li>
        )
    )
}